import { PhoneCase } from '@qcases/common';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ImageData, SquareItemModel } from '../../domain/SquareItem.model';
import { selectImage } from 'application/BackgroundImage/BackgroundImage.slice';

export interface CaseDesignerState {
  backgroundImageEditor: ImageData;
  backgroundImageResult: ImageData;
  isEditing: boolean;
}

const defaultImageData: ImageData = {
  imageUrl: '',
  rotationAngle: 0,
  zoom: 1,
  x: 0,
  y: 0,
};

const initialState: CaseDesignerState = {
  backgroundImageEditor: {
    ...defaultImageData,
  },
  backgroundImageResult: {
    ...defaultImageData,
  },
  isEditing: false,
};
export const caseDesignerSlice = createSlice({
  name: 'caseDesigner',
  initialState,
  reducers: {
    editBackgroundImage: state => {
      state.isEditing = true;
    },
    turnOffEditBackgroundImage: state => {
      state.isEditing = false;
    },
    draftEditImageData: (state, action: PayloadAction<ImageData>) => {
      state.backgroundImageEditor = action.payload;
    },
    resetEditingImageData: state => {
      // TODO: currently do not have this function
      if (!state.backgroundImageEditor) {
        return;
      }
    },
    clearEditingImageData: state => {
      if (!state.backgroundImageEditor) {
        return;
      }
      state.backgroundImageEditor = {
        imageUrl: '',
        rotationAngle: 0,
        zoom: 1,
        outputBase64ImageUrl: '',
        x: 0,
        y: 0,
      };
    },
    saveEditItemData: (state, action: PayloadAction<ImageData>) => {
      state.backgroundImageEditor = action.payload;
      state.backgroundImageResult = action.payload;
      state.isEditing = false;
    },
    setBackgroundImageEditorData: (state, action: PayloadAction<PhoneCase>) => {
      state.backgroundImageEditor = {
        imageUrl: '',
        rotationAngle: 0,
        x: 0,
        y: 0,
        zoom: 1,
        outputBase64ImageUrl: '',
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  editBackgroundImage,
  turnOffEditBackgroundImage,
  draftEditImageData,
  clearEditingImageData,
  resetEditingImageData,
  saveEditItemData,
  setBackgroundImageEditorData,
} = caseDesignerSlice.actions;

export const { reducer: caseDesignerReducer } = caseDesignerSlice;
